import {workExperienceEntries, generalExperiences, projectEntries, skills} from './ResumeEntries';
import "./Resume.css"

function Resume(){
    return(
        <section name="Resume" className='page-container resume-entry'>
                <h3 className='text-center'>R e s u m e</h3>
                <hr/>
                <div>
                    <h4>Work Experience</h4>
                    <PositionEntry entry={workExperienceEntries.job1}/>
                    <br/>
                    <PositionEntry entry={workExperienceEntries.job2}/>
                    <br/>
                    <PositionEntry entry={workExperienceEntries.job3}/>
                </div>
                <hr/>

                <div>
                    <h4>Experience</h4>
                    <ul className='dashed'>
                        {generalExperiences.map((item, index) => (
                            <Experience key={index} responsibility={item}/>
                        ))}
                    </ul>
                </div>
                <hr/>

                <div>
                    <h4>Projects</h4>
                    <PositionEntry entry={projectEntries.project1}/>
                    <br/>
                    <PositionEntry entry={projectEntries.project2}/>
                    <br/>
                    <PositionEntry entry={projectEntries.project3}/>
                    <br/>
                    <PositionEntry entry={projectEntries.project4}/>
                </div>
                <hr/>

                <div>
                    <h4>Education</h4>
                    <PositionEntry entry={{
                        company: "The University of the Arts",
                        position: "BFA in Animation",
                        dateRanges: "Sep. 2013 - May 2017",
                        responsibilities: []}}/>
                </div>

                <hr/>
                <div>
                    <h4>Skills</h4>
                    <p><b>{Object.keys(skills)[0]}</b> | <i>{skills['Operating Systems']}</i></p>
                    <p><b>{Object.keys(skills)[1]}</b> | <i>{skills['Software']}</i></p>
                    <p><b>{Object.keys(skills)[2]}</b> | <i>{skills['Programming']}</i></p>
                </div>
                <div className='TopSeperator'></div>
        </section>
    );
}

function PositionEntry({entry}){
    return(
        <>
            <p><b>{entry.company}</b> | {entry.position} <i>{entry.dateRanges}</i></p>
            <ul className='dashed'>
                {entry.responsibilities.map((item, index) => (
                    <Experience key={index} responsibility={item}/>
                ))}
            </ul>
        </>
    );
}

function Experience({responsibility}){
    return(
        <li>
            {responsibility}
        </li>
    );
}

export default Resume;